import axios from "axios";
import { Button } from "antd";
import { LayoutData } from "../Structur/Aconlayout";
import { GetConfigDaten } from "../Structur/Configurations";
import { Link } from "react-router-dom";
import { Resend } from "resend";
import { Html } from "@react-email/html";
import { useQuery, useMutation } from "@tanstack/react-query";
import ReactDOMServer from "react-dom/server";

const postEmailResendData = async (data, baseUrl, bearer) => {
  const response = await fetch(`${baseUrl}api/postresendemail`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${bearer}`,
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  return response.json();
};

//import { Email } from './email';

const RESEND_API_KEY = process.env.REACT_APP_RESEND_API_KEY;

export async function POST() {
  /*
  const res = await fetch("https://api.resend.com/emails", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${RESEND_API_KEY}`,
    },
    body: JSON.stringify({
      from: "Acme <onboarding@resend.dev>",
      to: ["christian.pohanka@gmail.com"],
      subject: "Test EMail",
      html: "<strong>it works!</strong>",
    }),
  });
  /*
  if (res.ok) {
    const data = await res.json();
    return NextResponse.json(data);
  }
  */
  /* das geht nur am Server wegen CORS policy !!
  const resend = new Resend(RESEND_API_KEY);

  const Email=(props)=> {
    const { url } = props;
    console.log("Erzeuge ein email ",url);
    return (
      <Html lang="en">
        Was kann das sein ??
        <button href={url}>Click me</button>
      </Html>
    );
  }

  await resend.emails.send({
    from: "Acme <onboarding@resend.dev>",
    to: ["christian.pohanka@gmail.com"],
    subject: "Test EMail",
    react: <Email url="https://www.google.com" />,
  });
  */
}

export const apiLogin = async (
  apiBaseUrl,
  userName,
  password,
  setUser,
  aktRespo
) => {
  try {
    console.log("globalBaseUrl", apiBaseUrl);
    //console.log("Anmeldung mit axios.post am API Server",userName, password);
    const respo = await axios.post(
      apiBaseUrl + (await GetConfigDaten(1)),
      //apiBaseUrl + "login",
      //apiBaseUrl + "api/permission/login",
      { email: userName, password: password }
      //  { headers: { Authorization: "Bearer my-token" } }
    );
    console.log("respo", respo);
    if (!respo.status) {
      return 400;
    }
    aktRespo.status = respo.status;
    //console.log("A-axios.post-response erfolgreich", respo.status);
    if (respo.status === 200) {
      aktRespo.bearer = respo.data.accessToken;
      aktRespo.expiresIn = respo.data.expiresIn;
      window.sessionStorage.setItem("accessToken", respo.data.accessToken);
      window.sessionStorage.setItem("expiresIn", respo.data.expiresIn);
      window.sessionStorage.setItem("tokenType", respo.data.tokenType);
      window.sessionStorage.setItem("refreshToken", respo.data.refreshToken);
      setUser((prevUser) => ({
        ...prevUser,
        name: userName,
        isAuthenticated: true,
        bearer: respo.data.accessToken,
        accessToken: respo.data.accessToken,
        expiresIn: respo.data.expiresIn,
        tokenType: respo.data.tokenType,
        refreshToken: respo.data.refreshToken,
      }));
    }
    return respo.status;
  } catch (error) {
    console.log("error", error);
    if (!aktRespo.status) {
      return 401;
    }
    if (error.response.status) aktRespo.status = error.response.status;
    else aktRespo.status = 401;
    return error.response.status;
  }
};

// baseUrl="https://pohanka.imendo.at:5405/"
export const NewGuid = (props) => {
  const openNewTab = () => {
    // URL deiner neuen Seite
    const newPageUrl = props.baseUrl + "api/newguid";
    // Öffne die neue Seite in einem neuen Tab
    window.open(newPageUrl, "_Blank");
  };
  const getLabel = () => {
    return props.label ? props.label : "New Guid";
  };
  return (
    <Button onClick={openNewTab} className="btn btn-secondary">
      {getLabel()}
    </Button>
  );
};
export const ApiTestNewGuid = () => {
  const { getApiBaseUrl, user } = LayoutData();

  const handleEMailText = () => {
    const doPostAsync = async (data) => {
      await postEmailResendData(data, getApiBaseUrl(), user.bearer);
    };
    const emailData = {
      Receiver: "christian.pohanka@gmail.com",
      Subject: "Daten aus der React APP",
      HtmlBody: ReactDOMServer.renderToStaticMarkup(
        <Html lang="de">
          Was kann das sein ??"Hier kommen noch die Daten aus der APP"
          <button href={"https://www.google.com"} target="_blank">Click me for Google</button>
          <hr />
          <center>
            <p>
              Mit dieser Funktion wird vom API Server eine neuen GUID
              angefordert.
              <br></br>
              Dies ist nur ein Test ob der Zugang zum API-Server möglich ist
              <br></br>
              Während der Entwicklung wird das Zertifikat eventuell nicht genau
              passen!<br></br>
              Erlauben Sie dem Browser den Zugang auch wenn er unsicher anzeigt!
            </p>
          </center>
        </Html>
      ),
    };

    emailData.TextBody="Das ist ein reines EMail als Text";

    doPostAsync(emailData);
  };

  return (
    <center>
      <p>
        Mit dieser Funktion wird vom API Server eine neuen GUID angefordert.
        <br></br>
        Dies ist nur ein Test ob der Zugang zum API-Server möglich ist<br></br>
        Während der Entwicklung wird das Zertifikat eventuell nicht genau
        passen!<br></br>
        Erlauben Sie dem Browser den Zugang auch wenn er unsicher anzeigt!
      </p>
      <p>
        <NewGuid
          label="Hier können Sie den Zugang prüfen"
          baseUrl={getApiBaseUrl()}
        />
      </p>
      <p>
        Es wird sich ein neuer Browser Tag öffnen.<br></br>
        Sobald die neue Guid angezeigt wird können Sie sich auch einloggen
        <br></br>
      </p>
      <p>
        <Button>
          <Link to="/PdfTestHome">Pdf Profi Home</Link>
        </Button>
      </p>
      {user && user.isAuthenticated && (
        <p>
          <Button onClick={handleEMailText}>EMail Test</Button>
        </p>
      )}
    </center>
  );
};

export const apiForgotPassword = async (apiBaseUrl, userName) => {
  try {
    console.log("globalBaseUrl", apiBaseUrl);
    //console.log("Anmeldung mit axios.post am API Server",userName, password);
    const respo = await axios.post(
      apiBaseUrl + "forgotPassword", //(await GetConfigDaten(1)),
      { email: userName }
      //  { headers: { Authorization: "Bearer my-token" } }
    );
    console.log("respo", respo);
    if (!respo.status) {
      return 400;
    }
    console.log("A-axios.post-response erfolgreich", respo.status);
    if (respo.status === 200) {
      return 200;
    }
    return respo.status;
  } catch (error) {
    console.log("error", error);
    return error.response.status;
  }
};
